/* unplugin-vue-components disabled */import script from "./NewsGroupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsGroupDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewsGroupDialog.vue?vue&type=style&index=0&id=9bbe25e6&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bbe25e6"]])

export default __exports__